import { IContactGroupAddress } from 'contacts/types';
import { IPricingProfileAccessItem } from 'pricing/types';

import { IPricingProfileAccessForm } from './types';

export const mapAccessItemToFormData = (
  accessItem: IPricingProfileAccessItem
): IPricingProfileAccessForm => {
  return {
    ...accessItem,
    customers: accessItem.customers.map((customer) => ({
      customerContactGroup: {
        id: customer.customerContactGroupId,
        name: customer.customerContactGroupName,
      },
      customerLocations: (customer.customerLocations || []).map((location) => ({
        id: location.customerAddressId,
        addressId: location.customerAddressId,
        name: location.customerAddressName,
      })) as IContactGroupAddress[],
    })),
    users: accessItem.users.map((user) => ({
      user: {
        id: user.corporateUserId,
        name: user.corporateUserName,
      },
    })),
    locations: accessItem.locations.map((location) => ({
      location: {
        id: location.corporateLocationId,
        name: location.corporateLocationAddressName,
      },
    })),
    regions: accessItem.regions.map((region) => ({
      region: {
        id: region.corporateRegionId,
        name: region.corporateRegionName,
      },
    })),
  };
};

export const mapUpsertPricingProfileAccess = (
  data: IPricingProfileAccessForm,
  pricingProfileAccessItem?: IPricingProfileAccessItem
) => {
  return {
    pricingAccessItem: {
      id: pricingProfileAccessItem?.id,
      pricingProfileId: data.pricingProfileId,
      allCustomers: data.allCustomers ? 1 : 0,
      allUsers: data.allUsers ? 1 : 0,
      allLocations: data.allLocations ? 1 : 0,
      allRegions: data.allRegions ? 1 : 0,
      customers:
        data.customers?.length > 0
          ? data.customers.map((customer) => ({
              customerContactGroupId: customer.customerContactGroup?.id,
              customerLocations:
                customer.customerLocations?.length > 0
                  ? customer.customerLocations?.map((location) => ({
                      customerAddressId: location.addressId,
                    }))
                  : undefined,
            }))
          : undefined,
      users:
        data.users?.length > 0
          ? data.users.map((user) => ({
              corporateUserId: user.user?.id,
            }))
          : undefined,
      locations:
        data.locations?.length > 0
          ? data.locations.map((location) => ({
              corporateLocationId: location.location?.id,
            }))
          : undefined,
      regions:
        data.regions?.length > 0
          ? data.regions.map((region) => ({
              corporateRegionId: region.region?.id,
            }))
          : undefined,
    },
  };
};
